import Region from '../../../constants/region';
import Environment from '../../Environment';
import MockSplit from '../../MockSplit';
import stages from '../stages';

const prod = new Environment({
    name: stages.PRODUCTION,
    regions: [],
});

const demo = new Environment({
    name: stages.DEMO,
    regions: [],
});

const staging = new Environment({
    name: stages.STAGING,
    evaluationFn: () => {
        return 'on';
    },
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: () => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    regions: [],
});

const can_use_new_route_session_table = new MockSplit({
    name: 'can_use_new_route_session_table',
    environments: [local, dev, staging, demo, prod],
});

export default can_use_new_route_session_table;
